import TagManager from 'react-gtm-module';

export const initializeGtm = gtmId => TagManager.initialize({ gtmId });
